/* eslint-disable no-console */
const defaultDigitoVerificador = 'k';
const invalidCharactersForRutRegex = /[-., ]/g;
const series = [2, 3, 4, 5, 6, 7];

const getDigitoVerificador = (rut) => {
  const reversedRut = `${rut}`.split('').reverse();
  let sum = 0;
  Object.keys(reversedRut).forEach((digit) => {
    const rutNumber = reversedRut[digit];
    sum += parseInt(rutNumber, 10) * series[digit % 6];
  });
  const modifier = sum % 11;
  const digitoVerificador = 11 - modifier;
  switch (digitoVerificador) {
    case 10:
      return defaultDigitoVerificador;
    case 11:
      return 0;
    default:
      return digitoVerificador;
  }
};

const isValidRut = (inputRut) => {
  const rawRut = inputRut.replace(invalidCharactersForRutRegex, '');
  const body = rawRut.substring(0, rawRut.length - 1);
  const digitoVerificador = rawRut.substring(rawRut.length - 1, rawRut.length).toLowerCase();
  const generatedDigitoVerificador = `${getDigitoVerificador(body)}`;
  return (digitoVerificador === generatedDigitoVerificador);
};

const cleanRut = (inputRut) => inputRut.replace(invalidCharactersForRutRegex, '');

const getTransactionFromUri = (uri) => {
  // NOTE: uri format for external transactions: cl-lpg:<account_number>?name=<name>&ident=<rut><dv>&bank=<id_bank>&payment_method=<account_type>&email=<email>
  const transaction = {};
  const validGatewayIds = ['cl-lpg', 'cl-bank', 'mx-spei'];
  let data = uri.split(':');
  if (!validGatewayIds.includes(data[0])) {
    throw new Error('ERROR: TransactionList.transactionFromURI: invalid gateway id in URI');
  }
  data = data[1].split('?');
  transaction.accountNumber = data[0]; // eslint-disable-line prefer-destructuring
  const params = data[1].split('&');
  params.forEach((param) => {
    const [key, value] = param.split('=');
    transaction[key] = value;
  });
  return transaction;
};

const buildExternalTransaction = ({ destUri, amount, currency, transactionId, desc, status, error }) => {
  let uriData;
  try {
    uriData = getTransactionFromUri(destUri);
  } catch (transactionError) {
    console.error('ERROR: TransactionList.render: unable to parse transaction data from URI', transactionError);
    return;
  }
  const nonUri = {
    amount,
    currency,
    id: transactionId,
    description: desc,
    status,
    error,
  };
  return { ...uriData, ...nonUri };
};

export { isValidRut, cleanRut, getTransactionFromUri, buildExternalTransaction };
